import { z } from 'zod';

/** Mirrors the Prisma enums in apps/api/prisma/schema.prisma (SPEC §2). */

export const ROLES = ['EMPLOYEE', 'SUPER_ADMIN'] as const;
export const roleSchema = z.enum(ROLES);
export type Role = z.infer<typeof roleSchema>;

export const LANGUAGES = ['EN', 'AR'] as const;
export const languageSchema = z.enum(LANGUAGES);
export type Language = z.infer<typeof languageSchema>;

export const AUDIO_STATUSES = [
  'PENDING',
  'GENERATING',
  'FAILED',
  'GENERATED',
  'APPROVED',
  'STALE',
] as const;
export const audioStatusSchema = z.enum(AUDIO_STATUSES);
export type AudioStatus = z.infer<typeof audioStatusSchema>;

export const RUN_STATUSES = ['RUNNING', 'COMPLETED', 'CANCELLED', 'ABORTED'] as const;
export const runStatusSchema = z.enum(RUN_STATUSES);
export type RunStatus = z.infer<typeof runStatusSchema>;

/** Server-side allowlist of ElevenLabs models (SPEC §8). */
export const ALLOWED_MODEL_IDS = ['eleven_multilingual_v2', 'eleven_flash_v2_5', 'eleven_v3'] as const;
export const modelIdSchema = z.enum(ALLOWED_MODEL_IDS);
export type ModelId = z.infer<typeof modelIdSchema>;

/** Delivery/transcode target (SPEC §8 publishing.deliveryFormat). */
export const DELIVERY_FORMATS = ['mp3', 'wav_8000', 'ulaw_8000'] as const;
export const deliveryFormatSchema = z.enum(DELIVERY_FORMATS);
export type DeliveryFormat = z.infer<typeof deliveryFormatSchema>;

/** Detected source encoding of an uploaded CSV (SPEC §5). */
export const DETECTED_ENCODINGS = ['utf-8', 'utf-8-bom', 'windows-1256'] as const;
export const detectedEncodingSchema = z.enum(DETECTED_ENCODINGS);
export type DetectedEncoding = z.infer<typeof detectedEncodingSchema>;

/** Delimiters auto-detected by the importer (SPEC §5). */
export const CSV_DELIMITERS = [',', ';', '\t'] as const;
export const csvDelimiterSchema = z.enum(CSV_DELIMITERS);
export type CsvDelimiter = z.infer<typeof csvDelimiterSchema>;

/** Abort reasons for a GenerationRun (SPEC §6). */
export const ABORT_REASONS = [
  'elevenlabs_auth',
  'elevenlabs_quota',
  'elevenlabs_forbidden',
  'cancelled_by_user',
  'unknown',
] as const;
export const abortReasonSchema = z.enum(ABORT_REASONS);
export type AbortReason = z.infer<typeof abortReasonSchema>;
